// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container__second-title-container {
  display: flex;
}
.main-container__second-title-container p {
  font-size: 18px;
  font-weight: bold;
  position: relative;
  top: 5px;
  margin-right: 12px;
}

.cron-builder-bg {
  background-color: #838383;
  border-radius: 5px;
  width: 95%;
  position: relative;
  left: 2.5%;
}
.cron-builder-bg:nth-child(3) {
  margin-bottom: 8px;
}
.cron-builder-bg:nth-child(4) {
  margin-bottom: 16px;
}

.tab-content {
  border: none;
}

.well.well-small {
  background-color: #fff;
  border-radius: 5px;
  border: none;
}

.cron_builder {
  background-color: #e8e8ed;
  border-radius: 10px;
  margin-bottom: 36px;
  border: none;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}
.cron_builder_bordering {
  background-color: #e8e8ed;
  border: none;
  padding: 15px;
  border-radius: 10px;
}
.cron_builder_bordering input {
  width: 190px;
  height: 28px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  background-color: #fff;
}
.cron_builder_bordering select {
  color: #666;
}

.cron_builder .well {
  margin-bottom: 15px;
}

.cron_builder .nav li a {
  color: #0abf53 !important;
}

.cron-builder-bg {
  background-color: white !important;
  color: #0abf53 !important;
  border: 2px solid #0abf53 !important;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/FirstMarketplace/FirstMarketplace.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAAE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;AAEJ;;AAgCA;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AA7BF;AA8BE;EACE,kBAAA;AA5BJ;AA8BE;EACE,mBAAA;AA5BJ;;AAgCA;EACE,YAAA;AA7BF;;AAgCA;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;AA7BF;;AAgCA;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA7BF;AA8BE;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA5BJ;AA6BI;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AA3BN;AA6BI;EACE,WAAA;AA3BN;;AAgCA;EACE,mBAAA;AA7BF;;AAgCA;EACE,yBAAA;AA7BF;;AAgCA;EACE,kCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gBAAA;AA7BF","sourcesContent":[".main-container__second-title-container {\n  display: flex;\n  p {\n    font-size: 18px;\n    font-weight: bold;\n    position: relative;\n    top: 5px;\n    margin-right: 12px;\n  }\n}\n\n// .nav {\n//   &-tabs {\n//     display: flex;\n//     align-items: center;\n//     background-color: #fff;\n//     height: 46px;\n//     border: none;\n//   }\n//   &-link {\n//     background-color: white;\n//     color: #0abf53;\n//     width: 100%;\n//     &.active {\n//       background-color: #e8e8ed;\n//       color: #666666;\n//       height: 46px;\n//       display: flex;\n//       align-items: center;\n//       justify-content: center;\n//       border-radius: 10px 10px 0px 0px;\n//     }\n//   }\n//   &-item {\n//     height: 46px;\n//     display: flex;\n//     align-items: center;\n//     border-radius: 10px 10px 0px 0px;\n//   }\n// }\n\n.cron-builder-bg {\n  background-color: #838383;\n  border-radius: 5px;\n  width: 95%;\n  position: relative;\n  left: 2.5%;\n  &:nth-child(3) {\n    margin-bottom: 8px;\n  }\n  &:nth-child(4) {\n    margin-bottom: 16px;\n  }\n}\n\n.tab-content {\n  border: none;\n}\n\n.well.well-small {\n  background-color: #fff;\n  border-radius: 5px;\n  border: none;\n}\n\n.cron_builder {\n  background-color: #e8e8ed;\n  border-radius: 10px;\n  margin-bottom: 36px;\n  border: none;\n  padding-top: 0;\n  padding-left: 0;\n  padding-right: 0;\n  &_bordering {\n    background-color: #e8e8ed;\n    border: none;\n    padding: 15px;\n    border-radius: 10px;\n    input {\n      width: 190px;\n      height: 28px;\n      border: 1px solid #cccccc;\n      border-radius: 5px;\n      background-color: #fff;\n    }\n    select {\n      color: #666;\n    }\n  }\n}\n\n.cron_builder .well {\n  margin-bottom: 15px;\n}\n\n.cron_builder .nav li a {\n  color: #0abf53 !important;\n}\n\n.cron-builder-bg {\n  background-color: white !important;\n  color: #0abf53 !important;\n  border: 2px solid #0abf53 !important;\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
